import React, { useState } from "react";
import './BikeCalc.css';

const bikeOptions = [
  { name: "Elcykel", price: 25000 },
  { name: "El-MTB", price: 30000 },
  { name: "Vanlig cykel", price: 10000 },
  { name: "MTB", price: 20000 },
  { name: "El-lådcykel", price: 40000 },
  { name: "Landsvägscykel", price: 28000 },
];

const BikeCalculator = () => {
  const [price, setPrice] = useState(30000);
  const [taxRate, setTaxRate] = useState(41);
  const [selectedBike, setSelectedBike] = useState("El-MTB");

  const leasingPremium = price * 0.03;
  const insurance = price * 0.004;
  const servicePackage = 85;
  const cycleBenefit = price * 0.014;
  const taxReduction = -250;
  const grossDeduction = leasingPremium + insurance + servicePackage;
  const taxCost = grossDeduction * (taxRate / 100);
  const netMonthlyCost = grossDeduction - taxCost;

  return (
    <div 
      className="p-6 max-w-3xl mx-auto bg-gray-100 rounded-lg shadow-md"
    >
      <h2 className="text-xl font-semibold mb-4">Räkna ut din månadskostnad</h2>

      <div className="flex space-x-2 mb-6">
        {bikeOptions.map((bike) => (
          <button
            key={bike.name}
            className={`px-4 py-2 border rounded ${
              selectedBike === bike.name ? "bg-black text-white" : "bg-white"
            }`}
            onClick={() => {
              setPrice(bike.price);
              setSelectedBike(bike.name);
            }}
          >
            {bike.name}
          </button>
        ))}
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">
          Cykelns pris inkl. moms: {price.toLocaleString()} kr
        </label>
        
        <input
          type="range"
          
          style={{
            width: '250px',
            accentColor: '#2A7966',
          }}
          min="10000"
          max="50000"
          value={price}
          onChange={(e) => setPrice(parseInt(e.target.value))}
          className="w-full"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">
          Marginalskatt: {taxRate} %
        </label>
        
        <input
          type="range"
          style={{
            width: '250px',
            accentColor: '#2A7966',
          }}
          min="10"
          max="50"
          value={taxRate}
          onChange={(e) => setTaxRate(parseInt(e.target.value))}
          className="w-full"
        />
      </div>

      <div className="p-4 text-white rounded-lg" style={{ backgroundColor: '#2A7966' }}>
        <h3 className="text-lg font-semibold">Månadskostnad</h3>
        <p className="text-2xl font-bold">{netMonthlyCost.toFixed(2)} kr</p>
      </div>

      <div className="bg-white p-8 rounded-lg shadow">
        <h3 className="text-lg font-bold">Din kalkyl</h3>
        <div className="">
          <ul className="text-left">
            <li><span className="font-bold">Cykelpris:</span> {price.toLocaleString()} kr</li>
            <li><span className="font-bold">Leasingpremie:</span> {leasingPremium.toFixed(0)} kr</li>
            <li><span className="font-bold">Försäkring:</span> {insurance.toFixed(0)} kr</li>
            <li><span className="font-bold">Servicepaket:</span> {servicePackage.toFixed(0)} kr</li>
            <li><span className="font-bold">Cykelförmånsvärde:</span> {cycleBenefit.toFixed(0)} kr</li>
            <li><span className="font-bold">Skattereduktion:</span> {taxReduction.toFixed(0)} kr</li>
            <li><span className="font-bold">Bruttolöneavdrag:</span> {grossDeduction.toFixed(0)} kr</li>
            <li><span className="font-bold">Marginalskatt:</span> {taxRate} %</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BikeCalculator;
